module.exports = __webpack_public_path__ + "static/media/bullet-point.c7498a9b.svg";